// extracted by mini-css-extract-plugin
export var footerContainer = "H_b4";
export var footerContent = "H_b6";
export var footerDisclosure = "H_b7";
export var menu = "H_b5";